<!-- 表单名称 -->
<template>
    <div v-if="componentsData.type == 1">
        <div class="bg-div" :style="bgStyle">
            <div
                v-if="componentsData.content.title"
                :style="titleStyle"
                class="title-box"
            >
                {{ componentsData.content.title }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    computed: {
        titleStyle() {
            const content = this.componentsData.content;
            return {
                fontSize: `${content.title_size}px`,
                color: content.title_color,
                textAlign: content.title_position,
            };
        },
        bgStyle() {
            const content = this.componentsData.content;
            const style = {};
            if (content.bg_color) {
                style.backgroundColor = content.bg_color;
            }
            const bgImg = content.bg_img || {};
            if (bgImg.picview && content.bg_value) {
                style.backgroundImage = `url(${bgImg.picview})`;
            }
            style.padding = `${content.inner_spacing.top}px ${content.inner_spacing.left}px`;
            style.margin = `${content.outer_spacing.top}px ${content.outer_spacing.left}px`;
            style.borderRadius = `${content.rounded_corner_setting.top}px ${content.rounded_corner_setting.top}px ${content.rounded_corner_setting.bottom}px ${content.rounded_corner_setting.bottom}px`;
            return style;
        },
    },
};
</script>

<style scoped>
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.title-box {
    font-weight: bold;
}
</style>
